import { jsx as _jsx } from "react/jsx-runtime";
export const GlobeIcon = ({
  color,
  width
}) => {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.25 19",
    enableBackground: "new 0 0 14.25 19",
    xmlSpace: "preserve",
    "aria-hidden": "true",
    width: width || 15,
    children: /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M13.9225,5.2324c0.6133,2.2106,0.3595,4.5326-0.7147,6.5393 c-1.0749,2.0067-2.8439,3.4614-4.9806,4.0957c-0.5524,0.1641-1.1122,0.2664-1.672,0.3114v1.5345h2.9005 c0.344,0,0.622,0.2882,0.622,0.6434c0,0.3558-0.278,0.6434-0.622,0.6434H2.4107c-0.344,0-0.622-0.2876-0.622-0.6434 c0-0.3551,0.278-0.6434,0.622-0.6434h2.9005v-1.546c-1.1818-0.0901-2.3413-0.4285-3.4068-1.0391 c-0.3011-0.1718-0.4093-0.5636-0.2432-0.8743c0.1667-0.3108,0.5461-0.4233,0.8453-0.2516c1.6496,0.9458,3.5605,1.1671,5.3774,0.6286 c1.8176-0.5398,3.3222-1.7764,4.2354-3.4826c0.9131-1.7062,1.1296-3.6808,0.6077-5.5607c-0.5219-1.8806-1.718-3.4363-3.367-4.3814 C9.0596,1.0337,8.9507,0.6425,9.1168,0.3318c0.1667-0.3114,0.5455-0.4227,0.846-0.2516C11.9028,1.192,13.3092,3.0217,13.9225,5.2324 z M11.875,7.5208c0,3.2738-2.6635,5.9375-5.9372,5.9375S0,10.7947,0,7.5208s2.6642-5.9375,5.9378-5.9375S11.875,4.247,11.875,7.5208 z"
    })
  });
};